// extracted by mini-css-extract-plugin
export default {"generic":"Bwm12y"};